import script from "./MallCartQuotePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallCartQuotePage.vue?vue&type=script&setup=true&lang=ts"

import "./MallCartQuotePage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__